/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const RuleLimitType = {
    PER_MONTH: 'PER_MONTH',
    PER_DAY: 'PER_DAY',
    PER_YEAR: 'PER_YEAR',
    PER_QUARTER: 'PER_QUARTER',
    PER_HOUR: 'PER_HOUR',
    PER_WEEK: 'PER_WEEK'
} as const;
export type RuleLimitType = typeof RuleLimitType[keyof typeof RuleLimitType];

